/** Portales del sitio. La clave apunta al namespace `topbar` de i18n. */
export const PORTAL_LINKS = [
  { key: "airport", href: "/" },
  { key: "corporate", href: "/corporativo" },
  { key: "cargo", href: "/carga" },
  { key: "regional", href: "/aeropuertos" },
] as const;
